import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, PageSize, RentalStockStatusOptions, StatusCodeActive } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import Dropdown from "components/Input/Dropdown";
import { CheckResponse, GetStatus, money } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "components/modal/ModalContext";
import Select from 'react-select'
import { FilterCard, PagesTitle } from "components/Cards";
import Pagination from "components/Input/PaginationButton";
import { useCallApi } from "api/apiHooks";
import SmallButton from "components/Button/SmallButton";

export default function RentalStock(){
    let navigate = useNavigate()
    
    const { openModal, closeModal } = useModal()
    const { fetchBrandList, fetchRentalStockList, fetchDeleteRentalStock } = useCallApi()

    const [productName, setProductName] = useState('')
    const [stockCode, setStockCode] = useState('')
    const [stockStatus, setStockStatus] = useState(RentalStockStatusOptions[0].value)
    const [brandOptions, setBrandOptions] = useState('')
    const [brand, setBrand] = useState('')
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [firstLoad, setFirstLaod] = useState(true)
    const [rentalStockList, setRentalStockList] = useState([])
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    
    // Button Event
    const addBtnClick = () => {
        navigate("/rental-stock/form?rentalStockId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/rental-stock/form?rentalStockId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = (id, status) => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                fetchDeleteRentalStock(id, status).then((res) => {
                    if (CheckResponse(res)) {
                        handlePageChange(pageIndex)
                        closeModal()
                    }                    
                })
            },
        })
    }

    // Function Grid
    async function handlePageChange(newIndex) {
        try {
            const res = await fetchRentalStockList(productName, brand === null || brand === '' ? '' : brand.value, stockCode, stockStatus, status, PageSize, newIndex)

            if (CheckResponse(res)) {
                const totalData = res?.data?.totalData ?? 0;
                const total = Math.max(1, Math.ceil(totalData / PageSize));

                setRentalStockList(res)
                setTotalPages(total);
                setPageIndex(newIndex);
            } else {
                openModal(ModalTypeFail, { message: res.message })
                return
            }
        } finally {
            closeModal();
        }
    }

    useEffect(() => {
        if (firstLoad) {
            openModal(ModalTypeLoading)
        }

        fetchBrandList('', '1', 10000, 0).then((res) => {
            if (CheckResponse(res)) {
                let data = res?.data?.listData
                let tempData = [{ label: 'All', value: '' }]

                data.map((data, i) => tempData.push({ label: data.brandName, value: String(data.brandId)}))

                setBrandOptions(tempData)
            } else {
                openModal(ModalTypeFail, { message: res.message })
            }
        }).finally(() => {
            handlePageChange(pageIndex)
            setFirstLaod(false)
        })
    },[brand, productName, stockStatus, status])

    return(
        <div className="flex flex-col gap-2 p-2 sm:p-6">
            <PagesTitle title='Rental Stock' />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-2">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <FilterCard title='Brand' width='w-72'>
                        <Select className="w-full" options={brandOptions} value={brand} onChange={(e) => { setBrand(e) }} placeholder='All' />
                    </FilterCard>
                    <FilterCard title='Product Name' width='w-72'>
                        <input className="input" value={productName} onChange={(e) => { setProductName(e.target.value) }} />
                    </FilterCard>
                    <FilterCard title='Status' width='w-32'>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                    </FilterCard>
                </div>
            </div>

            <div className="flex w-full justify-between bg-white p-2 rounded-xl shadow-md text-sm border">
                <div className="flex gap-2 ">
                    { RentalStockStatusOptions.map((data, i) => { return (
                        <div className={`border px-3 flex items-center rounded-full cursor-pointer ${stockStatus === data.value ? 'bg-black text-white' : ''} `}
                            onClick={() => { setStockStatus(data.value) }}
                        >
                            {data.label}
                        </div>
                    )})}
                </div>
                <div>
                    <SmallButton 
                        buttonName='Add Stock'
                        visible={true}
                        onClick={addBtnClick}
                        className='bg-black text-white'
                    />
                </div>
            </div>
           
            <div className="mt-2 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Stock Code</th>
                            <th className="font-semibold text-left px-2">Product Name</th>
                            <th className="font-semibold text-left px-2">Rental Price (Hour)</th>
                            <th className="font-semibold text-left px-2">Selling Price</th>
                            <th className="font-semibold text-left px-2">Stock Status</th>
                            <th className="font-semibold text-left px-2">Status</th>
                            <th className="font-semibold w-auto sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        { rentalStockList?.data?.listData?.length === 0 && (
                            <tr className="text-center h-12">
                               <td colSpan={8}>No Data Available</td> 
                            </tr>
                        )}
                        { rentalStockList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-1 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.stockCode }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.brandName } { data.productName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>Rp { money(data.rentalPriceHour) }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>Rp { money(data.sellingPrice) }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ RentalStockStatusOptions.find((x) => x.value === data.stockStatus).label  }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button gap-2 flex" onClick={() => editBtnClick(data.rentalStockId)}>
                                            <EditIcon className="w-3 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2`} onClick={() => deleteBtnClick(data.rentalStockId, data.status)}>
                                            {
                                                data.status === StatusCodeActive ? 
                                                (<TrashIcon className="w-3 fill-white" />) : 
                                                (<RevisionIcon className="w-3 fill-white" />)
                                            }
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </div>
    )
}

